const Telugu = {
  //COMMON
  nameRequired: "పేరు అవసరం.",
  firstNameRequired: "మొదటి పేరు అవసరం.",
  lastNameRequired: "చివరి పేరు అవసరం.",
  emailRequired: "ఇమెయిల్ అవసరం.",
  phoneRequired: "ఫోన్ నంబర్ అవసరం.",
  genderRequired: "లింగం అవసరం.",
  dobRequired: "జనన తేదీ అవసరం.",
  firstNamelength: "మొదటి పేరు కనీసం 3 అక్షరాలు ఉండాలి.",

  experienceRequired: "అనుభవం అవసరం.",
  suggestionRequired: "సూచన అవసరం.",
  onlyAlphabetsAllowed: "అక్షరాలు మరియు ఖాళీలు మాత్రమే అనుమతించబడతాయి.",

  //PROFILE
  pincodeRequired: "చెల్లుబాటు అయ్యే 6 అంకెల పిన్‌కోడ్ అవసరం.",
  stateRequired: "రాష్ట్రం అవసరం.",
  districtRequired: "జిల్లా అవసరం.",
  cityRequired: "నగరం/పట్టణం/గ్రామం అవసరం.",
  addressRequired: "చిరునామా అవసరం.",
  religionRequired: "మతం అవసరం.",
  templeFrequencyRequired: "దేవాలయ సందర్శన తరచుదనం అవసరం.",
  languageRequired: "భాష అవసరం.",
  phoneTenDigits: "ఫోన్ నంబర్ 10 అంకెలుగా ఉండాలి.",
  phonestarts: "సంఖ్య 0 తో ప్రారంభం కావ нельзяదు.",
  aadharInvalid: "ఆధార్ నంబర్ 12 అంకెలుగా ఉండాలి.",
  passportInvalid:
    "పాస్‌పోర్ట్ నంబర్ 1 అక్షరం మరియు 7 అంకెలుగా ఉండాలి (ఉదా: K1234567).",
  firstNameInvalid: "మొదటి పేరు అక్షరాలు మరియు ఖాళీలు మాత్రమే కలిగి ఉండాలి.",
  lastNameInvalid: "చివరి పేరు అక్షరాలు మరియు ఖాళీలు మాత్రమే కలిగి ఉండాలి.",

  // PASSWORD
  currentPasswordRequired: "ప్రస్తుత పాస్‌వర్డ్ అవసరం.",
  newPasswordRequired: "కొత్త పాస్‌వర్డ్ అవసరం.",
  confirmPasswordRequired: "పాస్‌వర్డ్ ధృవీకరణ అవసరం.",
  currentPasswordInvalid:
    "ప్రస్తుత పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి, ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం, ఒక సంఖ్య, మరియు ఒక ప్రత్యేక చిహ్నం ఉండాలి.",
  newPasswordInvalid:
    "కొత్త పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి, ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం, ఒక సంఖ్య, మరియు ఒక ప్రత్యేక చిహ్నం ఉండాలి.",
  confirmPasswordInvalid:
    "ధృవీకరణ పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి, ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం, ఒక సంఖ్య, మరియు ఒక ప్రత్యేక చిహ్నం ఉండాలి.",
  passwordsNotMatch: "కొత్త పాస్‌వర్డ్ మరియు ధృవీకరణ పాస్‌వర్డ్ సరిపోలడం లేదు.",
  emojiNotAllowed:"పాస్‌వర్డ్‌లో ఎమోజీలకు అనుమతి లేదు.",
  incorrectCurrentPassword: "మీరు నమోదు చేసిన ప్రస్తుత పాస్‌వర్డ్ తప్పు.",
  sameAsCurrentPassword:
    "కొత్త పాస్‌వర్డ్ ప్రస్తుత పాస్‌వర్డ్ తో సమానం కాకూడదు.",

  //IMAGE
  fileTooLarge: "ఫైల్ పరిమాణం 2MB మించకూడదు.",
  invalidFileType:
    "చెల్లని ఫైల్ రకం. దయచేసి JPG/JPEG లేదా PNG చిత్రాన్ని అప్లోడ్ చేయండి.",
  imageUploadFailed: "చిత్రం అప్లోడ్ విఫలమయ్యింది. దయచేసి మళ్లీ ప్రయత్నించండి.",
};

export default Telugu;
